<template>
  <div class="swiper-area program-list youtube">
    <div class="swiper-header">
      <div class="left-area w100">
        <div
          class="tit-area youtube title--hover"
          @click="goGweduYoutubeChannel()"
        >
          <p class="tit">유튜브</p>
        </div>
      </div>
      <div class="right-area pl0 pb0">
        <div class="custom-label">
          <span class="label label-new"
                :class="youtubeList === listPortletNewReg ? 'is-checked' : ''"
                @click="changeSelectYoutube(viewCountOrDate.date)">신규등록</span>
          <span class="label label-max"
                :class="youtubeList === listPortletMostViewed ? 'is-checked' : ''"
                @click="changeSelectYoutube(viewCountOrDate.viewCount)">최다조회</span>
        </div>
      </div>
    </div>
    <!-- body -->
    <div class="swiper-body">
      <div class="control-bar">
        <div class="swiper-button-prev swiper-youtube-prev" slot="button-prev">
          <span class="material-icons">arrow_back_ios</span>
        </div>
        <div class="swiper-button-next swiper-youtube-next" slot="button-next">
          <span class="material-icons">arrow_forward_ios</span>
        </div>
      </div>
      <div class="no-data" v-if=" 1 > youtubeList.length">
        <i class="material-icons">error_outline</i>
        <p>데이터가 없습니다.</p>
      </div>
      <swiper v-else ref="programSwiper" class="program-swiper youtube"
              :options="programSwiperOptions">
        <swiper-slide v-for="(youtube,index1) in youtubeList" :key="index1">
          <div class="thumb-area" :class="{ 'no-image': youtube.thumbnail === noImage }">
            <img :src="youtube.thumbnail" @click="goLink(youtube.videoId)" alt=""/>
          </div>
          <div class="txt-area">
            <span class="tit" v-text="youtube.title">진짜 같은 가짜, 로봇 물고기</span>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-youtube mob-visible"></div>
    </div>
  </div>
</template>
<script>
import noImage from "~/assets/images/portal/sample/no_image.png";
import portalApiUrl from '~/constant/site/portal/portalApiUrl';

const URL_PORTLET_YOUTUBE = '/api/user/v1/youtube/portalUserPortletApi_getYouTubePortlet';

export default {
  name: "ThePortletYoutubeList",

  created() {
    this.searchList();
    this.youtubeList = this.listPortletNewReg;
    this.viewType = "dd"
  },
  data() {
    return {
      noImage,

      programSwiperOptions: {
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
        },
        slidesPerView: 2,
        spaceBetween: 16,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".swiper-youtube-next",
          prevEl: ".swiper-youtube-prev"
        },
        setWrapperSize: true,
        breakpoints: {
          1024: {
            slidesPerView: 2.6,
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 20,
          },
          500: {
            slidesPerView: 2.24,
            spaceBetween: 18,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        }
      },

      //최다조회
      listPortletMostViewed: [],
      //신규등록
      listPortletNewReg: [],

      //화면에보이는 유튜브 리스트
      youtubeList: [],

      //버튼 색깔
      buttonColor: 'primary',
      buttonColor2: 'gray',

      // 최다조회 또는 신규등록
      viewCountOrDate: {
        viewCount: "viewCount",
        date: "date",
      },

      // 최다조회 : p , 신규등록 : dd
      viewType: ''

    }
  },

  methods: {
    searchList() {
      const param = {
        oid: "",
      };

      this.$axios.post( portalApiUrl.USER.PORTLET.GET_YOUTUBE_PORTLET, param ).then( res => {

        let tempParse = JSON.parse( res.data.contents );
        if ( this.$validate.isEmpty( tempParse ) ) {
          return;
        }

        const listPortletMostViewedTemp = tempParse.viewCount.items;
        const listPortletNewRegTemp = tempParse.date.items;

        // 최다조회
        for ( const portlet of listPortletMostViewedTemp ) {

          // portlet.snippet.thumbnails.high.url= 0 ;
          let thumbnail = this.$validate.isNotEmpty( portlet.snippet.thumbnails.high.url )
            ? portlet.snippet.thumbnails.high.url : noImage

          const porletMostViewed = {
            thumbnail: thumbnail,
            title: portlet.snippet.title,
            videoId: portlet.id.videoId,
          }

          this.listPortletMostViewed.push( porletMostViewed );
        }

        // 신규등록
        for ( const portlet of listPortletNewRegTemp ) {

          let thumbnail = this.$validate.isNotEmpty( portlet.snippet.thumbnails.high.url )
            ? portlet.snippet.thumbnails.high.url : noImage

          const porletMostNewReg = {
            thumbnail: thumbnail,
            title: portlet.snippet.title,
            videoId: portlet.id.videoId
          }

          this.listPortletNewReg.push( porletMostNewReg );

        }

      } );
    },

    goLink( videoId ) {

      const youtubeLink = "https://www.youtube.com/watch?v=" + videoId

      window.open( youtubeLink );

    },

    goGweduYoutubeChannel() {

      const viewType = this.viewType
      window.open( `https://www.youtube.com/@gwedu` );
    },

    /**
     *
     */
    changeSelectYoutube( viewCountOrDate ) {

      if ( "viewCount" === viewCountOrDate ) {
        this.youtubeList = this.listPortletMostViewed;
        this.buttonColor = "primary"
        this.buttonColor2 = "gray"
        this.viewType = "p"
      }

      if ( "date" === viewCountOrDate ) {
        this.youtubeList = this.listPortletNewReg;
        this.buttonColor = "gray"
        this.buttonColor2 = "primary"
        this.viewType = "dd"

      }
    },

  },

  computed: {
    swiper() {
      return this.$refs.programSwiper.$swiper
    },
  },
}
</script>
<style scoped>
</style>
